<template>
    <div class="comm-region-form">
     <el-button type="primary" style="margin-bottom: 25px" @click="openModal">
    <i class="fa-solid fa-plus"></i> &nbsp; {{ $t('Yeni_ərazi') }}
</el-button>

        <el-table :data="mappings" v-loading="loadingTable" style="width: 100%">
            <el-table-column prop="officerName" :label="$t('Qəza_komissarı')" width="400" />
            <el-table-column prop="regionName" :label="$t('Ərazilər')" :show-overflow-tooltip="false" />
            <el-table-column align="right" fixed="right" width="50">
                <template #default="{ row }">
                    <el-dropdown trigger="click">
                        <el-button type="text" class="custom-button" style="padding: 0 10px 0 0 !important;">
                            <div class="square-icon">
                                <i class="fas fa-ellipsis-h" :title="$t('Əməliyyatlar')" style="color: #808080;"></i>
                            </div>
                        </el-button>
                     <el-dropdown-menu slot="dropdown">
    <el-dropdown-item @click.native="editMapping(row)">
        <i class="fa-solid fa-pen-to-square"></i>&nbsp;{{ $t('Düzəliş') }}
    </el-dropdown-item>
    <el-dropdown-item @click.native="deleteMapping(row)">
        <i class="fa-solid fa-trash"></i>&nbsp;{{ $t('Sil') }}
    </el-dropdown-item>
</el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>

        </el-table>  

        <el-dialog :title="$t('Ərazi_bölgüsü')" :visible.sync="dialogVisible" width="30%" v-loading="loading">
            <el-form :model="form" ref="regionForm" label-width="120px" :rules="rules" size="small">
                <el-form-item :label="$t('Komissar')" prop="officerId">
                    <el-select v-model="form.officerId" :placeholder="$t('Seçin')" style="width: 100%">
                        <el-option v-for="o in officers" :key="o.id" :label="o.name" :value="o.id" />
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('Ərazilər')" prop="regionIds">
                    <el-select v-model="form.regionIds" multiple :placeholder="$t('Seçin')" style="width: 100%">
                        <el-option v-for="r in allRegions" :key="r.id" :label="r.name" :value="r.id" />
                    </el-select>
                </el-form-item>

                <el-form-item class="text-right">
                    <el-button type="primary" @click="submit">{{$t('Yadda_saxla')}}</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { GetCommRegions, UpdateCommRegions, DeleteCommRegions } from "../../services/commregion";
import { GetRegions } from "../../services/cls";
import { usersbyrole } from "../../services/sales";

export default {
    data() {
        return {
            mappings: [],
            allRegions: [],
            officers: [],
            dialogVisible: false,
            loading: false,
            loadingTable: false,
            form: {
                officerId: null,
                regionIds: [],
            },
            rules: {
                officerId: [{ required: true, message: this.$t('Sütun_mütləqdir_1'), trigger: "blur" }],
                regionIds: [{ required: true, message: this.$t('Sütun_mütləqdir_1'), trigger: "change" }],
            },
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData() {
            this.loadingTable = true;
            try {
                await this.fetchOfficers();
                await this.fetchRegions();
                await this.fetchMappings();
            } finally {
                this.loadingTable = false;
            }
        },

        async fetchOfficers() {
            const res = await usersbyrole(4);
            this.officers = res.data;
        },

        async fetchRegions() {
            const res = await GetRegions();
            this.allRegions = res.data.data;
        },

        async fetchMappings() {
            const res = await GetCommRegions();
            this.mappings = res.data.data.map(item => {
                const officer = this.officers.find(o => o.id === item.accidentComm);
                return {
                    ...item,
                    officerName: officer ? officer.name : "—",
                };
            });
        },

        openModal() {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.resetForm()
            })
        },

        resetForm() {
            if (this.$refs.regionForm) {
                this.$refs.regionForm.resetFields()
            }
            this.form = {
                officerId: null,
                regionIds: [],
            }
        },

        editMapping(row) {
            this.form = {
                officerId: row.accidentComm,
                regionIds: row.regionId ? row.regionId.split(",").map(id => parseInt(id)) : [],
            };
            this.dialogVisible = true;
        },

        submit() {
            this.$refs.regionForm.validate(valid => {
                if (!valid) return;

                const payload = {
                    accidentComm: this.form.officerId,
                    regionId: this.form.regionIds.join(","),
                    user: this.$store.state.user.id,
                };

                this.loading = true;
                UpdateCommRegions(payload)
                    .then(() => {
                        this.dialogVisible = false;
                        this.$message.success(this.$t('Uğurlu_əməliyyat_1'));
                        this.fetchMappings();
                    })
                    .catch(() => this.$message.error(this.$t('Xəta_baş_verdi')))
                    .finally(() => (this.loading = false));
            });
        },

        deleteMapping(row) {
            this.$confirm(this.$t('Silmək_istədiyinizə_əminsiniz'), this.$t('Təsdiq'), {
                confirmButtonText: this.$t('Bəli'),
                cancelButtonText: "Xeyr",
                type: "warning",
            })
                .then(() => {
                    DeleteCommRegions({ accidentComm: row.accidentComm })
                        .then(() => {
                            this.$message.success(this.$t('Uğurlu_əməliyyat_1'));
                            this.fetchMappings();
                        })
                        .catch(() => this.$message.error(this.$t('Xəta_baş_verdi')));
                })
                .catch(() => { });
        },
    },
};
</script>

<style scoped>
.comm-region-form ::v-deep .el-table__body .cell {
    overflow: visible;
    text-overflow: clip;
}
</style>